<script>
import { mapGetters } from "vuex";
import ActivityList from "../components/pages/ActivityList.vue";
import NotesModalList from "../components/notes/NotesModalList.vue";
import Recipe from "./Recipe.vue";
export default {
  components: { ActivityList, NotesModalList, Recipe },
  name: "Activity",
  data() {
    return {
      tabIndex: 0,
      tabs: ["activities", "workouts", "warmups", "stretch-flows"],
      currentPage: 1,
    };
  },
  ...mapGetters({
    currentPaginationPage: "commons/currentPaginationPage",
    currentDataList: "commons/currentDataList",
  }),
  watch: {
    tabIndex(val) {
      this.$store.commit("commons/setPreloader", true);
      this.$store.commit("commons/setCurrentPaginationPage", 1)
      if (val != 5 && val != 4) {
        this.$store
          .dispatch("commons/listByType", {
            limit: 25,
            type: this.tabs[val],
            offset: 1,
            search: null,
          })
          .then(() => {
            this.$store.commit("commons/setPreloader", false);
          });
      }
      if (val == 4) {
        this.$store
          .dispatch(`recipes/getRecipes`, {
            limit: 25,
            offset: 0,
            search: "",
          })
          .then(() => {
            this.$store.commit("commons/setPreloader", false);
          });
      }
    },
  },
  mounted() {
    this.$store.dispatch(`commons/getFieldOptions`);
    this.$store.commit("commons/setPreloader", true);
    this.$store
      .dispatch("commons/listByType", {
        limit: 25,
        type: this.tabs[0],
        offset: 1,
        search: null,
      })
      .then(() => {
        this.$store.commit("commons/setPreloader", false);
      });
  },
};
</script>
<style lang="scss">
.data-listing-tabs {
  .tabs {
    .card-header {
      .card-header-tabs {
        li {
          width: auto;
          a {
            padding-left: 25px;
            padding-right: 25px;
            border-bottom: 0 !important;
            background: #efefef;
            text-transform: capitalize;
            &.active {
              border-bottom: 0 !important;
            }
            &.disabled {
              background: transparent;
              cursor: not-allowed;
            }
          }
        }
      }
    }
  }
}
</style>>

<template>
  <div>
    <b-card no-body class="data-listing-tabs">
      <b-tabs card v-model="tabIndex">
        <b-tab title="All" active>
          <activity-list :type="'activities'"> </activity-list>
        </b-tab>
        <b-tab title="Workouts">
          <activity-list :type="'workouts'"> </activity-list>
        </b-tab>
        <b-tab title="Warm Up">
          <activity-list :type="'warmups'"> </activity-list>
        </b-tab>
        <b-tab title="Stretch Flow">
          <activity-list :type="'stretch-flows'"> </activity-list>
        </b-tab>
        <b-tab title="Recipes">
          <recipe> </recipe>
        </b-tab>
        <b-tab title="learn">
        </b-tab>
      </b-tabs>
    </b-card>
    <notes-modal-list> </notes-modal-list>
  </div>
</template>
